module.exports = __webpack_public_path__ + "static/creditkey-logo-2ac01a6dffba63f9437c40ec6d4e87a4.png";